import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CachedIcon from '@mui/icons-material/Cached';
import { useParties } from '../../../contexts/PartiesContext';

interface DirectionProps {
  sender: string;
  receiver: string;
}
export const Direction: React.FC<DirectionProps> = ({ sender, receiver }) => {
  const { party } = useParties();
  if (party === sender && party !== receiver) {
    return <ArrowForwardIcon sx={{ scale: 0.5 }} color="error" />;
  }
  if (party === receiver && party !== sender) {
    return <ArrowBackIcon sx={{ scale: 0.5 }} color="success" />;
  }
  if (party === receiver && party === sender) {
    return <CachedIcon color="action" sx={{ scale: 0.5 }} />;
  }
  return null;
};
